import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useRef, useState } from "react";
import Story from "@componentsShared/Story/Story";
import stl from "./RadioCard.module.css";
import { useTranslation } from "@i18n";
import Countdown from "react-countdown";
import { trackEvents } from "@/common/events/events";
var RadioCard = function RadioCard(_ref) {
  var dataName = _ref.dataName,
    name = _ref.name,
    checked = _ref.checked,
    onChange = _ref.onChange,
    value = _ref.value,
    className = _ref.className,
    error = _ref.error,
    disabled = _ref.disabled,
    children = _ref.children,
    story = _ref.story,
    storyText = _ref.storyText,
    campaignData = _ref.campaignData,
    isFinance = _ref.isFinance,
    setCampaignModal = _ref.setCampaignModal,
    g4Data = _ref.g4Data,
    CardFooter = _ref.CardFooter;
  var storyRef = useRef();
  var _useState = useState(false),
    ShowStory = _useState[0],
    setShowStory = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-name": dataName || "",
    className: "".concat(stl.RadioWrapper, " ").concat(checked ? stl.checked : "", " ").concat(className ? className : "", " ").concat(error ? stl.hasError : "", "  ").concat(disabled && stl.disabled)
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.customRadio
  }), children), storyText && /*#__PURE__*/React.createElement("div", {
    className: stl.stryBtn,
    onClick: function onClick() {
      return setShowStory(true);
    }
  }, storyText), campaignData && /*#__PURE__*/React.createElement("div", {
    className: stl.campaign,
    style: {
      backgroundColor: campaignData === null || campaignData === void 0 ? void 0 : campaignData.bg_color
    }
  }, /*#__PURE__*/React.createElement("div", null, campaignData === null || campaignData === void 0 ? void 0 : campaignData.text), /*#__PURE__*/React.createElement("div", null, campaignData !== null && campaignData !== void 0 && campaignData.counter_timestamp ? /*#__PURE__*/React.createElement("span", {
    className: stl.countdownWrapper
  }, /*#__PURE__*/React.createElement(Countdown, {
    date: (campaignData === null || campaignData === void 0 ? void 0 : campaignData.counter_timestamp) * 1000,
    daysInHours: true,
    onComplete: function onComplete() {},
    renderer: function renderer(_ref2) {
      var hours = _ref2.hours,
        minutes = _ref2.minutes,
        seconds = _ref2.seconds,
        days = _ref2.days;
      return /*#__PURE__*/React.createElement("div", {
        className: stl.countdown
      }, days > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, days * 24, " ")) : /*#__PURE__*/React.createElement("strong", null, hours < 10 ? "0".concat(hours) : hours + days * 24), ":", /*#__PURE__*/React.createElement("strong", null, minutes < 10 ? "0".concat(minutes) : minutes), " ", ":", /*#__PURE__*/React.createElement("strong", null, seconds < 10 ? "0".concat(seconds) : seconds));
    }
  })) : null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      trackEvents("marketing_theme_click", _objectSpread(_objectSpread({}, g4Data), {}, {
        has_timer: campaignData !== null && campaignData !== void 0 && campaignData.counter_timestamp ? true : false,
        theme_type: isFinance ? "Finance" : "Cash"
      }));
      setCampaignModal(isFinance ? "finance" : "cash");
    }
  }, t("اعرف اكثر", {
    ns: "web_pre_checkout"
  })))), CardFooter && /*#__PURE__*/React.createElement("div", null, CardFooter)), /*#__PURE__*/React.createElement(Story, {
    ref: storyRef,
    showStoryMode: ShowStory,
    closeStory: function closeStory() {
      return setShowStory(false);
    }
  }, story && story));
};
export default RadioCard;